/** Community LIVE tech spec submissions (separate from admin-vetted VRC venue doc). */
export const LIVE_COMMUNITY_STATUS = 'live';
export const LIVE_COMMUNITY_HIDDEN_STATUS = 'hidden';
export const LIVE_COMMUNITY_SOURCE = 'live_community';

export const LIVE_TECH_SPEC_FIELDS = [
  'capacity',
  'adaAccessibilityArtist',
  'parking',
  'shorePower',
  'backstage',
  'merch',
  'stage',
  'backline',
  'video',
  'monitors',
  'pa',
  'power',
  'foh',
  'lightingControl',
  'lightingFixtures',
  'notes',
];

export function isSignedInAccount(user) {
  return Boolean(user?.uid) && user.isAnonymous !== true;
}

export function isLiveCommunityTechSpecReport(report) {
  return Boolean(
    report?.isTechSpecsOnly &&
      (report.submissionSource === LIVE_COMMUNITY_SOURCE || report.status === LIVE_COMMUNITY_STATUS)
  );
}

export function isPublicLiveCommunityReport(report) {
  return (
    isLiveCommunityTechSpecReport(report) &&
    !report.promotedToVrc &&
    report.status !== LIVE_COMMUNITY_HIDDEN_STATUS
  );
}

export function sortLiveReportsNewestFirst(reports) {
  return [...reports].sort((a, b) => {
    const ta = a?.createdAt?.toDate ? a.createdAt.toDate().getTime() : new Date(a?.createdAt || 0).getTime();
    const tb = b?.createdAt?.toDate ? b.createdAt.toDate().getTime() : new Date(b?.createdAt || 0).getTime();
    return tb - ta;
  });
}

// Admin > Venue Reports (BUG-089): reports are grades; tech specs are the venue info sheet.
// The list shows one kind at a time so tech specs never show up as reports.
export function matchesVenueReportKind(report, techSpecsOnly) {
  return techSpecsOnly ? Boolean(report?.isTechSpecsOnly) : !report?.isTechSpecsOnly;
}
